// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var $947b03da4811c942$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), $947b03da4811c942$var$module, false);
var // end source content
$947b03da4811c942$export$2e2bcd8739ae039 = $947b03da4811c942$var$module.exports;
var $947b03da4811c942$export$185802fd694ee1f5 = $947b03da4811c942$var$module.exports.create;


// package.json
var $0dea53fbf8dad186$var$name = "@vercel/analytics";
var $0dea53fbf8dad186$var$version = "1.5.0";
// src/queue.ts
var $0dea53fbf8dad186$var$initQueue = ()=>{
    if (window.va) return;
    window.va = function a(...params) {
        (window.vaq = window.vaq || []).push(params);
    };
};
// src/utils.ts
function $0dea53fbf8dad186$var$isBrowser() {
    return typeof window !== "undefined";
}
function $0dea53fbf8dad186$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $0dea53fbf8dad186$var$setMode(mode = "auto") {
    if (mode === "auto") {
        window.vam = $0dea53fbf8dad186$var$detectEnvironment();
        return;
    }
    window.vam = mode;
}
function $0dea53fbf8dad186$var$getMode() {
    const mode = $0dea53fbf8dad186$var$isBrowser() ? window.vam : $0dea53fbf8dad186$var$detectEnvironment();
    return mode || "production";
}
function $0dea53fbf8dad186$var$isProduction() {
    return $0dea53fbf8dad186$var$getMode() === "production";
}
function $0dea53fbf8dad186$var$isDevelopment() {
    return $0dea53fbf8dad186$var$getMode() === "development";
}
function $0dea53fbf8dad186$var$removeKey(key, { [key]: _, ...rest }) {
    return rest;
}
function $0dea53fbf8dad186$var$parseProperties(properties, options) {
    if (!properties) return void 0;
    let props = properties;
    const errorProperties = [];
    for (const [key, value] of Object.entries(properties))if (typeof value === "object" && value !== null) {
        if (options.strip) props = $0dea53fbf8dad186$var$removeKey(key, props);
        else errorProperties.push(key);
    }
    if (errorProperties.length > 0 && !options.strip) throw Error(`The following properties are not valid: ${errorProperties.join(", ")}. Only strings, numbers, booleans, and null are allowed.`);
    return props;
}
function $0dea53fbf8dad186$export$c689ba62f1421710(pathname, pathParams) {
    if (!pathname || !pathParams) return pathname;
    let result = pathname;
    try {
        const entries = Object.entries(pathParams);
        for (const [key, value] of entries)if (!Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value);
            if (matcher.test(result)) result = result.replace(matcher, `/[${key}]`);
        }
        for (const [key, value] of entries)if (Array.isArray(value)) {
            const matcher = $0dea53fbf8dad186$var$turnValueToRegExp(value.join("/"));
            if (matcher.test(result)) result = result.replace(matcher, `/[...${key}]`);
        }
        return result;
    } catch (e) {
        return pathname;
    }
}
function $0dea53fbf8dad186$var$turnValueToRegExp(value) {
    return new RegExp(`/${$0dea53fbf8dad186$var$escapeRegExp(value)}(?=[/?#]|$)`);
}
function $0dea53fbf8dad186$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $0dea53fbf8dad186$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($0dea53fbf8dad186$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/script.debug.js";
    if (props.basePath) return `${props.basePath}/insights/script.js`;
    return "/_vercel/insights/script.js";
}
// src/generic.ts
function $0dea53fbf8dad186$export$a976684a0efeb93f(props = {
    debug: true
}) {
    var _a;
    if (!$0dea53fbf8dad186$var$isBrowser()) return;
    $0dea53fbf8dad186$var$setMode(props.mode);
    $0dea53fbf8dad186$var$initQueue();
    if (props.beforeSend) (_a = window.va) == null || _a.call(window, "beforeSend", props.beforeSend);
    const src = $0dea53fbf8dad186$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $0dea53fbf8dad186$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $0dea53fbf8dad186$var$version;
    if (props.disableAutoTrack) script.dataset.disableAutoTrack = "1";
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/insights`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    script.onerror = ()=>{
        const errorMessage = $0dea53fbf8dad186$var$isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
        console.log(`[Vercel Web Analytics] Failed to load script from ${src}. ${errorMessage}`);
    };
    if ($0dea53fbf8dad186$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    document.head.appendChild(script);
}
function $0dea53fbf8dad186$export$6b2a7d5132615086(name2, properties, options) {
    var _a, _b;
    if (!$0dea53fbf8dad186$var$isBrowser()) {
        const msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";
        if ($0dea53fbf8dad186$var$isProduction()) console.warn(msg);
        else throw new Error(msg);
        return;
    }
    if (!properties) {
        (_a = window.va) == null || _a.call(window, "event", {
            name: name2,
            options: options
        });
        return;
    }
    try {
        const props = $0dea53fbf8dad186$var$parseProperties(properties, {
            strip: $0dea53fbf8dad186$var$isProduction()
        });
        (_b = window.va) == null || _b.call(window, "event", {
            name: name2,
            data: props,
            options: options
        });
    } catch (err) {
        if (err instanceof Error && $0dea53fbf8dad186$var$isDevelopment()) console.error(err);
    }
}
function $0dea53fbf8dad186$export$b81f1580747d8b3a({ route: route, path: path }) {
    var _a;
    (_a = window.va) == null || _a.call(window, "pageview", {
        route: route,
        path: path
    });
}
var $0dea53fbf8dad186$export$2e2bcd8739ae039 = {
    inject: $0dea53fbf8dad186$export$a976684a0efeb93f,
    track: $0dea53fbf8dad186$export$6b2a7d5132615086,
    computeRoute: $0dea53fbf8dad186$export$c689ba62f1421710
};


var $ca33d0e756dcd6e1$exports = {};
"use strict";
var $ca33d0e756dcd6e1$var$__defProp = Object.defineProperty;
var $ca33d0e756dcd6e1$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ca33d0e756dcd6e1$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ca33d0e756dcd6e1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca33d0e756dcd6e1$var$__export = (target, all)=>{
    for(var name2 in all)$ca33d0e756dcd6e1$var$__defProp(target, name2, {
        get: all[name2],
        enumerable: true
    });
};
var $ca33d0e756dcd6e1$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $ca33d0e756dcd6e1$var$__getOwnPropNames(from))if (!$ca33d0e756dcd6e1$var$__hasOwnProp.call(to, key) && key !== except) $ca33d0e756dcd6e1$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $ca33d0e756dcd6e1$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $ca33d0e756dcd6e1$var$__toCommonJS = (mod)=>$ca33d0e756dcd6e1$var$__copyProps($ca33d0e756dcd6e1$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/generic.ts
var $ca33d0e756dcd6e1$var$generic_exports = {};
$ca33d0e756dcd6e1$var$__export($ca33d0e756dcd6e1$var$generic_exports, {
    computeRoute: ()=>$ca33d0e756dcd6e1$var$computeRoute,
    default: ()=>$ca33d0e756dcd6e1$var$generic_default,
    injectSpeedInsights: ()=>$ca33d0e756dcd6e1$var$injectSpeedInsights
});
$ca33d0e756dcd6e1$exports = $ca33d0e756dcd6e1$var$__toCommonJS($ca33d0e756dcd6e1$var$generic_exports);
// package.json
var $ca33d0e756dcd6e1$var$name = "@vercel/speed-insights";
var $ca33d0e756dcd6e1$var$version = "1.2.0";
// src/queue.ts
var $ca33d0e756dcd6e1$var$initQueue = ()=>{
    if (window.si) return;
    window.si = function a(...params) {
        (window.siq = window.siq || []).push(params);
    };
};
// src/utils.ts
function $ca33d0e756dcd6e1$var$isBrowser() {
    return typeof window !== "undefined";
}
function $ca33d0e756dcd6e1$var$detectEnvironment() {
    try {
        const env = "production";
        if (env === "development" || env === "test") return "development";
    } catch (e) {}
    return "production";
}
function $ca33d0e756dcd6e1$var$isDevelopment() {
    return $ca33d0e756dcd6e1$var$detectEnvironment() === "development";
}
function $ca33d0e756dcd6e1$var$computeRoute(pathname, pathParams) {
    if (!pathname || !pathParams) return pathname;
    let result = pathname;
    try {
        const entries = Object.entries(pathParams);
        for (const [key, value] of entries)if (!Array.isArray(value)) {
            const matcher = $ca33d0e756dcd6e1$var$turnValueToRegExp(value);
            if (matcher.test(result)) result = result.replace(matcher, `/[${key}]`);
        }
        for (const [key, value] of entries)if (Array.isArray(value)) {
            const matcher = $ca33d0e756dcd6e1$var$turnValueToRegExp(value.join("/"));
            if (matcher.test(result)) result = result.replace(matcher, `/[...${key}]`);
        }
        return result;
    } catch (e) {
        return pathname;
    }
}
function $ca33d0e756dcd6e1$var$turnValueToRegExp(value) {
    return new RegExp(`/${$ca33d0e756dcd6e1$var$escapeRegExp(value)}(?=[/?#]|$)`);
}
function $ca33d0e756dcd6e1$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $ca33d0e756dcd6e1$var$getScriptSrc(props) {
    if (props.scriptSrc) return props.scriptSrc;
    if ($ca33d0e756dcd6e1$var$isDevelopment()) return "https://va.vercel-scripts.com/v1/speed-insights/script.debug.js";
    if (props.dsn) return "https://va.vercel-scripts.com/v1/speed-insights/script.js";
    if (props.basePath) return `${props.basePath}/speed-insights/script.js`;
    return "/_vercel/speed-insights/script.js";
}
// src/generic.ts
function $ca33d0e756dcd6e1$var$injectSpeedInsights(props = {}) {
    var _a;
    if (!$ca33d0e756dcd6e1$var$isBrowser() || props.route === null) return null;
    $ca33d0e756dcd6e1$var$initQueue();
    const src = $ca33d0e756dcd6e1$var$getScriptSrc(props);
    if (document.head.querySelector(`script[src*="${src}"]`)) return null;
    if (props.beforeSend) (_a = window.si) == null || _a.call(window, "beforeSend", props.beforeSend);
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    script.dataset.sdkn = $ca33d0e756dcd6e1$var$name + (props.framework ? `/${props.framework}` : "");
    script.dataset.sdkv = $ca33d0e756dcd6e1$var$version;
    if (props.sampleRate) script.dataset.sampleRate = props.sampleRate.toString();
    if (props.route) script.dataset.route = props.route;
    if (props.endpoint) script.dataset.endpoint = props.endpoint;
    else if (props.basePath) script.dataset.endpoint = `${props.basePath}/speed-insights/vitals`;
    if (props.dsn) script.dataset.dsn = props.dsn;
    if ($ca33d0e756dcd6e1$var$isDevelopment() && props.debug === false) script.dataset.debug = "false";
    script.onerror = ()=>{
        console.log(`[Vercel Speed Insights] Failed to load script from ${src}. Please check if any content blockers are enabled and try again.`);
    };
    document.head.appendChild(script);
    return {
        setRoute: (route)=>{
            script.dataset.route = route ?? void 0;
        }
    };
}
var $ca33d0e756dcd6e1$var$generic_default = {
    injectSpeedInsights: $ca33d0e756dcd6e1$var$injectSpeedInsights,
    computeRoute: $ca33d0e756dcd6e1$var$computeRoute
};


(0, $ca33d0e756dcd6e1$exports.injectSpeedInsights)();
(0, $0dea53fbf8dad186$export$a976684a0efeb93f)();
let $b63be9b0371e788c$var$currentProblem;
let $b63be9b0371e788c$var$gameMode = 'input';
let $b63be9b0371e788c$var$selectedNumbers = [];
let $b63be9b0371e788c$var$problems = [];
let $b63be9b0371e788c$var$correctAnswers = 0;
let $b63be9b0371e788c$var$totalAttempts = 0;
let $b63be9b0371e788c$var$timeLeft = Infinity;
let $b63be9b0371e788c$var$timerInterval;
let $b63be9b0371e788c$var$isUnlimited = true;
let $b63be9b0371e788c$var$totalQuestions = 0;
let $b63be9b0371e788c$var$currentQuestionNumber = 0;
let $b63be9b0371e788c$var$isChecking = false;
let $b63be9b0371e788c$var$isSoundMuted = localStorage.getItem('isSoundMuted') === 'true';
let $b63be9b0371e788c$var$answersHistory = {
    correct: [],
    wrong: []
};
function $b63be9b0371e788c$var$init() {
    const imageUrl = 'https://images.unsplash.com/photo-1695923142527-9b43a467b298?q=80&w=1600&auto=format&fit=crop&ixlib=rb-4.0.3';
    // Preload image
    const img = new Image();
    img.src = imageUrl;
    img.onload = ()=>{
        console.log('Image preloaded');
        document.getElementById('learnSection').style.backgroundImage = `url('${imageUrl}')`;
    };
}
$b63be9b0371e788c$var$init();
function $b63be9b0371e788c$var$updateTimer() {
    const timerElement = document.getElementById('time-left');
    const timerContainer = document.getElementById('timer');
    timerElement.textContent = $b63be9b0371e788c$var$timeLeft;
    // Remove any existing warning classes
    timerContainer.classList.remove('warning-mild', 'warning-severe');
    // Add appropriate warning class based on time left
    if ($b63be9b0371e788c$var$timeLeft <= 15 && $b63be9b0371e788c$var$timeLeft > 5) timerContainer.classList.add('warning-mild');
    else if ($b63be9b0371e788c$var$timeLeft <= 5) timerContainer.classList.add('warning-severe');
// console.log("Time Left: "+timeLeft);
}
function $b63be9b0371e788c$var$setSelectedNumbers() {
    $b63be9b0371e788c$var$selectedNumbers = [];
    document.querySelectorAll('.checkbox-grid input[type="checkbox"]:checked').forEach((checkbox)=>{
        $b63be9b0371e788c$var$selectedNumbers.push(parseInt(checkbox.value));
    });
    localStorage.setItem('selectedNumbers', $b63be9b0371e788c$var$selectedNumbers);
}
function $b63be9b0371e788c$var$updateQuestionCounters() {
    document.getElementById('currentQuestion').textContent = $b63be9b0371e788c$var$currentQuestionNumber;
    document.getElementById('totalQuestions').textContent = $b63be9b0371e788c$var$totalQuestions;
}
function $b63be9b0371e788c$var$updateScoreDisplay() {
    document.getElementById('correct').textContent = $b63be9b0371e788c$var$correctAnswers;
    document.getElementById('incorrect').textContent = $b63be9b0371e788c$var$totalAttempts - $b63be9b0371e788c$var$correctAnswers;
}
function $b63be9b0371e788c$var$resetTimers() {
    setDifficulty(document.getElementById("difficulty").value);
}
function $b63be9b0371e788c$var$startTimer() {
    document.getElementById('timer').style.display = 'flex';
    $b63be9b0371e788c$var$timerInterval = setInterval(()=>{
        $b63be9b0371e788c$var$timeLeft--;
        $b63be9b0371e788c$var$updateTimer();
        if ($b63be9b0371e788c$var$timeLeft <= 0) {
            clearInterval($b63be9b0371e788c$var$timerInterval);
            $b63be9b0371e788c$var$endGame();
        }
    }, 1000);
}
function $b63be9b0371e788c$var$clearAnswersHistory() {
    $b63be9b0371e788c$var$answersHistory = {
        correct: [],
        wrong: []
    };
}
function $b63be9b0371e788c$var$resetAll(num) {
    // Reset scores and history for new attempt
    $b63be9b0371e788c$var$correctAnswers = 0;
    $b63be9b0371e788c$var$totalAttempts = 0;
    $b63be9b0371e788c$var$currentQuestionNumber = 0; // Reset to 0
    $b63be9b0371e788c$var$totalQuestions = num;
    clearInterval($b63be9b0371e788c$var$timerInterval);
    $b63be9b0371e788c$var$clearAnswersHistory();
    // Update displays
    $b63be9b0371e788c$var$updateQuestionCounters();
    $b63be9b0371e788c$var$updateScoreDisplay();
    //reset timers
    $b63be9b0371e788c$var$resetTimers();
}
// Modify your existing displayResults function:
function $b63be9b0371e788c$var$displayResults() {
    const correctList = document.getElementById('correctAnswersList');
    const wrongList = document.getElementById('wrongAnswersList');
    const retryButton = document.getElementById('retryButton');
    const continueButton = document.getElementById('continueButton');
    const endAllQuestions = $b63be9b0371e788c$var$totalAttempts === $b63be9b0371e788c$var$totalQuestions;
    const timeUsed = $b63be9b0371e788c$var$getTimeLimit() - $b63be9b0371e788c$var$timeLeft;
    let messageOfAnswers = `\u{5E2}\u{5E0}\u{5D9}\u{5EA}\u{5DD} \u{5E2}\u{5DC} ${$b63be9b0371e788c$var$correctAnswers} \u{5E9}\u{5D0}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5DB}\u{5D5}\u{5DF} \u{5DE}\u{5EA}\u{5D5}\u{5DA} ${$b63be9b0371e788c$var$totalQuestions}`;
    if (!$b63be9b0371e788c$var$isUnlimited) messageOfAnswers = `\u{5E2}\u{5E0}\u{5D9}\u{5EA}\u{5DD} \u{5D1} ${timeUsed} \u{5E9}\u{5E0}\u{5D9}\u{5D5}\u{5EA}  \u{5E2}\u{5DC} ${$b63be9b0371e788c$var$correctAnswers} \u{5E9}\u{5D0}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5DB}\u{5D5}\u{5DF} \u{5DE}\u{5EA}\u{5D5}\u{5DA} ${$b63be9b0371e788c$var$totalQuestions}  `;
    document.querySelector('.final-score p').textContent = messageOfAnswers;
    // Add perfect score message if applicable
    const scoreMessage = document.querySelector('.final-score h2');
    if ($b63be9b0371e788c$var$answersHistory.wrong.length === 0 && $b63be9b0371e788c$var$totalAttempts === $b63be9b0371e788c$var$totalQuestions) {
        scoreMessage.textContent = "\uD83C\uDF1F \u05E2\u05E0\u05D9\u05EA\u05DD \u05E2\u05DC \u05D4\u05DB\u05DC \u05DE\u05D5\u05E9\u05DC\u05DD! \uD83C\uDF1F";
        scoreMessage.classList.add('perfect-score');
        $b63be9b0371e788c$var$celebratePerfectScore();
    } else if (endAllQuestions || $b63be9b0371e788c$var$timeLeft <= 0) {
        scoreMessage.textContent = "\u05D4\u05EA\u05E8\u05D2\u05D5\u05DC \u05D4\u05E1\u05EA\u05D9\u05D9\u05DD!";
        scoreMessage.classList.remove('perfect-score');
    } else {
        scoreMessage.textContent = "\u05D9\u05E9 \u05E2\u05D5\u05D3 \u05E9\u05D0\u05DC\u05D5\u05EA \u05DC\u05EA\u05E8\u05D2\u05DC, \u05E7\u05D3\u05D9\u05DE\u05D4 \u05D1\u05D5\u05D0\u05D5 \u05E0\u05DE\u05E9\u05D9\u05DA";
        scoreMessage.classList.remove('perfect-score');
    }
    // Create correct answers section
    const correctSection = document.querySelector('.correct-answers');
    correctSection.style.display = $b63be9b0371e788c$var$answersHistory.correct.length > 0 ? 'block' : 'none';
    correctList.innerHTML = $b63be9b0371e788c$var$answersHistory.correct.map((item)=>`<div class="answer-item correct-item">
            ${item.num1} \xd7 ${item.num2} = ${item.num1 * item.num2}
        </div>`).join('');
    // Create wrong answers section
    const wrongSection = document.querySelector('.wrong-answers');
    wrongSection.style.display = $b63be9b0371e788c$var$answersHistory.wrong.length > 0 ? 'block' : 'none';
    wrongList.innerHTML = $b63be9b0371e788c$var$answersHistory.wrong.map((item)=>`<div class="answer-item wrong-item">
        ${item.missingFactor ? `${item.num1} \xd7 <span class="wrong-answer">${item.userAnswer}</span> <span class="correct-solution">(${item.answer})</span> = ${item.num1 * item.num2}` : `${item.num1} \xd7 ${item.num2} = <span class="wrong-answer">${item.userAnswer}</span> <span class="correct-solution">(${item.answer})</span>`}
    </div>`).join('');
    // Adjust layout if only one section is visible
    if ($b63be9b0371e788c$var$answersHistory.correct.length > 0 && $b63be9b0371e788c$var$answersHistory.wrong.length === 0) correctSection.style.width = '100%';
    else if ($b63be9b0371e788c$var$answersHistory.wrong.length > 0 && $b63be9b0371e788c$var$answersHistory.correct.length === 0) wrongSection.style.width = '100%';
    if (continueButton) continueButton.style.display = endAllQuestions || $b63be9b0371e788c$var$timeLeft <= 0 ? 'none' : 'block';
    // Show or hide retry button based on whether there are mistakes
    if (retryButton) retryButton.style.display = endAllQuestions && $b63be9b0371e788c$var$answersHistory.wrong.length > 0 ? 'block' : 'none';
}
// Modify your endGame function to ensure proper state reset:
function $b63be9b0371e788c$var$endGame() {
    $b63be9b0371e788c$var$displayResults();
    document.getElementById('backdrop').style.display = 'block';
    const modal = document.getElementById('finalScore');
    modal.style.display = 'block';
    modal.setAttribute('tabindex', '-1'); // Allows the modal to receive focus
    modal.focus();
}
function $b63be9b0371e788c$var$showNextProblem() {
    if ($b63be9b0371e788c$var$problems.length === 0) {
        clearInterval($b63be9b0371e788c$var$timerInterval);
        $b63be9b0371e788c$var$endGame();
        return;
    }
    $b63be9b0371e788c$var$currentProblem = $b63be9b0371e788c$var$problems.pop();
    const prob = $b63be9b0371e788c$var$currentProblem.missingFactor ? `${$b63be9b0371e788c$var$currentProblem.num1} \xd7 ? = ${$b63be9b0371e788c$var$currentProblem.num1 * $b63be9b0371e788c$var$currentProblem.num2}` : `${$b63be9b0371e788c$var$currentProblem.num1} \xd7 ${$b63be9b0371e788c$var$currentProblem.num2} = ?`;
    document.getElementById('problem').textContent = prob;
    // Clear previous result
    document.getElementById('result').classList.add('hide');
    const questionCard = document.getElementById('questionCard');
    questionCard.classList.remove('correct-animation');
    questionCard.classList.remove('.wrong-animation');
    questionCard.classList.remove('.wrong-animation-input');
    // Show/hide appropriate input method based on mode
    const inputMode = document.getElementById('inputMode');
    const multipleChoiceMode = document.getElementById('multipleChoiceMode');
    if ($b63be9b0371e788c$var$gameMode === 'input') {
        inputMode.style.display = 'flex';
        multipleChoiceMode.style.display = 'none';
        // Setup input mode
        const answerInput = document.getElementById('answer');
        answerInput.value = '';
        answerInput.focus();
    } else {
        inputMode.style.display = 'none';
        multipleChoiceMode.style.display = 'flex';
        // Setup multiple choice mode
        const options = $b63be9b0371e788c$var$generateOptions($b63be9b0371e788c$var$currentProblem);
        const optionsContainer = document.getElementById('answerOptions');
        optionsContainer.innerHTML = options.map((option, index)=>`
            <button 
                class="answer-option" 
                data-value="${option.value}" 
                data-correct="${option.isCorrect}"
                onclick="checkMultipleChoice(this)"
            >
                ${option.value}
            </button>
        `).join('');
    }
}
// Function to play sound
function $b63be9b0371e788c$var$playSound(isCorrect) {
    if ($b63be9b0371e788c$var$isSoundMuted) return;
    try {
        const sound = document.getElementById(isCorrect ? 'correctSound' : 'wrongSound');
        if (sound) {
            sound.currentTime = 0; // Reset sound to start
            const playPromise = sound.play();
            if (playPromise !== undefined) playPromise.catch((error)=>{
                console.log('Sound play failed:', error);
            });
        }
    } catch (error) {
        console.log('Error playing sound:', error);
    }
}
function $b63be9b0371e788c$var$exitPractice() {
    // End the game and show results
    $b63be9b0371e788c$var$endGame();
}
function $b63be9b0371e788c$var$celebratePerfectScore() {
    const colors = [
        '#a864fd',
        '#29cdff',
        '#78ff44',
        '#ff718d',
        '#fdff6a'
    ];
    const duration = 4000;
    const end = Date.now() + duration;
    if (!$b63be9b0371e788c$var$isSoundMuted) {
        const celebrationSound = document.getElementById('celebrationSound');
        celebrationSound.play().catch((e)=>console.log('Sound play failed:', e));
    }
    // Initial burst with all colors
    (0, $947b03da4811c942$export$2e2bcd8739ae039)({
        particleCount: 150,
        spread: 100,
        colors: colors,
        origin: {
            y: 0.7
        }
    });
    // Continuous animation
    (function frame() {
        // Get two random colors for each burst
        const randomColors = colors.sort(()=>Math.random() - 0.5).slice(0, 2);
        // Left cannon
        (0, $947b03da4811c942$export$2e2bcd8739ae039)({
            particleCount: 4,
            angle: 60,
            spread: 50,
            origin: {
                x: 0
            },
            colors: randomColors
        });
        // Right cannon
        (0, $947b03da4811c942$export$2e2bcd8739ae039)({
            particleCount: 4,
            angle: 120,
            spread: 50,
            origin: {
                x: 1
            },
            colors: randomColors
        });
        // Center bursts every 600ms
        if (Date.now() % 600 < 50) (0, $947b03da4811c942$export$2e2bcd8739ae039)({
            particleCount: 40,
            spread: 80,
            colors: colors,
            origin: {
                y: 0.65
            }
        });
        if (Date.now() < end) requestAnimationFrame(frame);
    })();
}
function $b63be9b0371e788c$var$generateOptions(currentProblem) {
    const correctAnswer = currentProblem.answer;
    let options = new Set(); // Use Set to avoid duplicates
    // 1. Add correct answer
    options.add({
        value: correctAnswer,
        isCorrect: true,
        type: 'correct'
    });
    // 2. Add one number off by 1 (randomly choose +1 or -1)
    const offByOneValue = Math.random() < 0.5 ? correctAnswer + 1 : correctAnswer - 1;
    options.add({
        value: offByOneValue,
        type: 'off-by-one'
    });
    let adjacentOptions = currentProblem.missingFactor ? $b63be9b0371e788c$var$getHardModeOptions(currentProblem.answer) : $b63be9b0371e788c$var$getRegularModeOptions(currentProblem);
    // Shuffle adjacent options to randomize which ones we use
    adjacentOptions = adjacentOptions.sort(()=>Math.random() - 0.5);
    // Add unique adjacent options until we have 4 total options
    for (let option of adjacentOptions)if (options.size < 4 && !Array.from(options).some((opt)=>opt.value === option.value)) options.add(option);
    // Convert to array and shuffle
    let finalOptions = Array.from(options);
    return finalOptions.sort(()=>Math.random() - 0.5);
}
function $b63be9b0371e788c$var$getHardModeOptions(correctAns) {
    return [
        {
            value: correctAns + 1,
            type: 'plus-one'
        },
        {
            value: correctAns + 2,
            type: 'plus-two'
        },
        {
            value: correctAns - 1,
            type: 'minus-one'
        },
        {
            value: correctAns > 2 ? correctAns - 2 : correctAns + 3,
            type: 'minus-two'
        }
    ];
}
function $b63be9b0371e788c$var$getRegularModeOptions({ num1: num1, num2: num2, answer: answer }) {
    return [
        {
            value: num1 * (num2 - 1),
            type: 'subjacent'
        },
        {
            value: (num1 - 1) * num2,
            type: 'subjacent-second'
        },
        {
            value: num1 * (num2 + 1),
            type: 'adjacent'
        },
        {
            value: (num1 + 1) * num2,
            type: 'adjacent-second'
        },
        {
            value: num1 * (num2 + 2),
            type: 'far-adjacent'
        },
        {
            value: answer + 2,
            type: 'off-by-two'
        }
    ];
}
function $b63be9b0371e788c$var$generateMultiplicationRows(num) {
    let rows = '';
    for(let i = 1; i <= 10; i++)rows += `
            <div class="multiplication-row">
                ${num} \xd7 ${i} = ${num * i}
            </div>
        `;
    return rows;
}
// Add this to your JavaScript file
function $b63be9b0371e788c$var$setupModalCloseOnBackdropClick() {
    // For message modal
    const messageModal = document.getElementById('messageModal');
    if (messageModal) messageModal.onclick = function(event) {
        if (event.target === messageModal) closeMessage();
    };
    // For end game modal and backdrop
    const finalScore = document.getElementById('finalScore');
    const backdrop = document.getElementById('backdrop');
    if (finalScore && backdrop) backdrop.onclick = function() {
        closeResults();
    };
}
function $b63be9b0371e788c$var$showMessage(message) {
    const modal = document.getElementById('messageModal');
    const messageText = document.getElementById('messageText');
    messageText.textContent = message;
    modal.style.display = 'flex';
}
// ---- PUBLIC
window.startPractice = function() {
    $b63be9b0371e788c$var$setSelectedNumbers();
    if ($b63be9b0371e788c$var$selectedNumbers.length === 0) {
        $b63be9b0371e788c$var$showMessage("\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DC\u05D5\u05D7 \u05DB\u05E4\u05DC \u05D0\u05D7\u05D3");
        return;
    }
    // Calculate total questions and reset counters
    $b63be9b0371e788c$var$resetAll($b63be9b0371e788c$var$selectedNumbers.length * 10);
    // Generate problems
    $b63be9b0371e788c$var$problems = [];
    const isHardMode = document.getElementById('missingFactor').checked;
    $b63be9b0371e788c$var$gameMode = document.getElementById('multiChoice').checked ? 'multiChoice' : 'input';
    // set the questions
    for (let num of $b63be9b0371e788c$var$selectedNumbers){
        for(let i = 1; i <= 10; i++)if (isHardMode && Math.random() < 0.5) $b63be9b0371e788c$var$problems.push({
            num1: num,
            num2: i,
            multiplication: num * i,
            answer: i,
            missingFactor: true
        });
        else {
            const first = Math.random() < 0.5 ? num : i;
            $b63be9b0371e788c$var$problems.push({
                num1: first,
                num2: num * i / first,
                multiplication: num * i,
                answer: num * i,
                missingFactor: false
            });
        }
    }
    $b63be9b0371e788c$var$problems = $b63be9b0371e788c$var$problems.sort(()=>Math.random() - 0.5);
    if (!$b63be9b0371e788c$var$isUnlimited) {
        clearInterval($b63be9b0371e788c$var$timerInterval);
        $b63be9b0371e788c$var$startTimer();
    }
    // Show practice section
    document.getElementById('configSection').classList.add('hidden');
    document.getElementById('practiceSection').classList.remove('hidden');
    document.getElementById('questionCard').style.display = 'flex';
    $b63be9b0371e788c$var$showNextProblem();
};
window.closeMessage = function() {
    document.getElementById('messageModal').style.display = 'none';
};
window.closeLearnMode = function() {
    document.querySelector('.flip-container').classList.remove('flip-to-learn');
    setTimeout(()=>{
        // Hide learn section
        document.getElementById('learnSection').classList.add('hidden');
        // Show configuration section
        document.getElementById('configSection').classList.remove('hidden');
    }, 200);
};
window.startLearnMode = function() {
    // Set selected numbers
    $b63be9b0371e788c$var$setSelectedNumbers();
    if ($b63be9b0371e788c$var$selectedNumbers.length === 0) {
        $b63be9b0371e788c$var$showMessage("\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D0\u05D7\u05D3");
        return;
    }
    const learnSection = document.getElementById('learnSection');
    // Generate multiplication tables
    const learnContainer = learnSection.querySelector('.learn-container');
    learnContainer.innerHTML = $b63be9b0371e788c$var$selectedNumbers.map((num)=>`
        <div class="multiplication-table">
            <div class="table-title"><div class="table-title-header"> ${num}</div></div>
            ${$b63be9b0371e788c$var$generateMultiplicationRows(num)}
        </div>
    `).join('');
    document.querySelector('.flip-container').classList.add('flip-to-learn');
    setTimeout(()=>{
        // Hide configuration section
        document.getElementById('configSection').classList.add('hidden');
        // Show learn section
        learnSection.classList.remove('hidden');
    }, 200);
};
window.checkAnswer = function() {
    if ($b63be9b0371e788c$var$isChecking) return; // If already checking, exit function
    $b63be9b0371e788c$var$isChecking = true; // Set flag to prevent multiple clicks/keypresses
    const answerInput = document.getElementById('answer');
    const checkButton = answerInput.nextElementSibling;
    const userAnswer = parseInt(answerInput.value);
    if (isNaN(userAnswer)) {
        $b63be9b0371e788c$var$isChecking = false;
        return;
    }
    checkButton.disabled = true; // Disable button to prevent multiple clicks
    const resultDiv = document.getElementById('result');
    const questionCard = document.getElementById('questionCard');
    $b63be9b0371e788c$var$totalAttempts++;
    if (userAnswer === $b63be9b0371e788c$var$currentProblem.answer) {
        $b63be9b0371e788c$var$correctAnswers++;
        resultDiv.textContent = "\u05E0\u05DB\u05D5\u05DF!";
        resultDiv.style.color = "green";
        questionCard.classList.add('correct-animation');
        $b63be9b0371e788c$var$playSound(true); // Play correct sound
        $b63be9b0371e788c$var$answersHistory.correct.push({
            num1: $b63be9b0371e788c$var$currentProblem.num1,
            num2: $b63be9b0371e788c$var$currentProblem.num2,
            answer: $b63be9b0371e788c$var$currentProblem.answer,
            missingFactor: $b63be9b0371e788c$var$currentProblem.missingFactor
        });
    } else {
        resultDiv.textContent = "\u05D8\u05E2\u05D5\u05EA!";
        resultDiv.style.color = "red";
        questionCard.classList.add('wrong-animation-input');
        $b63be9b0371e788c$var$playSound(false); // Play wrong sound
        $b63be9b0371e788c$var$answersHistory.wrong.push({
            num1: $b63be9b0371e788c$var$currentProblem.num1,
            num2: $b63be9b0371e788c$var$currentProblem.num2,
            answer: $b63be9b0371e788c$var$currentProblem.answer,
            missingFactor: $b63be9b0371e788c$var$currentProblem.missingFactor,
            userAnswer: userAnswer
        });
    }
    resultDiv.classList.remove('hide');
    $b63be9b0371e788c$var$updateScoreDisplay();
    $b63be9b0371e788c$var$currentQuestionNumber++;
    $b63be9b0371e788c$var$updateQuestionCounters();
    setTimeout(()=>{
        questionCard.classList.remove('correct-animation');
        questionCard.classList.remove('wrong-animation-input');
        $b63be9b0371e788c$var$showNextProblem();
        checkButton.disabled = false;
        $b63be9b0371e788c$var$isChecking = false;
    }, 700);
};
// Function to toggle sound
window.toggleSound = function() {
    $b63be9b0371e788c$var$isSoundMuted = !$b63be9b0371e788c$var$isSoundMuted;
    const soundIcon = document.getElementById('soundIcon');
    soundIcon.classList.toggle('muted', $b63be9b0371e788c$var$isSoundMuted);
    soundIcon.classList.toggle('unmuted', !$b63be9b0371e788c$var$isSoundMuted);
    // Save preference to localStorage
    localStorage.setItem('isSoundMuted', $b63be9b0371e788c$var$isSoundMuted);
};
window.checkMultipleChoice = function(selectedButton) {
    const isCorrect = selectedButton.dataset.correct === 'true';
    const resultDiv = document.getElementById('result');
    const questionCard = document.getElementById('questionCard');
    $b63be9b0371e788c$var$totalAttempts++;
    if (isCorrect) {
        $b63be9b0371e788c$var$correctAnswers++;
        resultDiv.textContent = "\u05E0\u05DB\u05D5\u05DF!";
        resultDiv.style.color = "green";
        selectedButton.classList.add('correct');
        questionCard.classList.add('correct-animation');
        $b63be9b0371e788c$var$playSound(true);
        $b63be9b0371e788c$var$answersHistory.correct.push({
            num1: $b63be9b0371e788c$var$currentProblem.num1,
            num2: $b63be9b0371e788c$var$currentProblem.num2,
            answer: $b63be9b0371e788c$var$currentProblem.answer,
            missingFactor: $b63be9b0371e788c$var$currentProblem.missingFactor
        });
    } else {
        resultDiv.textContent = "\u05D8\u05E2\u05D5\u05EA!";
        resultDiv.style.color = "red";
        selectedButton.classList.add('wrong');
        // Show correct answer
        document.querySelectorAll('.answer-option').forEach((button)=>{
            if (button.dataset.correct === 'true') button.classList.add('correct');
        });
        questionCard.classList.add('wrong-animation');
        $b63be9b0371e788c$var$playSound(false);
        $b63be9b0371e788c$var$answersHistory.wrong.push({
            num1: $b63be9b0371e788c$var$currentProblem.num1,
            num2: $b63be9b0371e788c$var$currentProblem.num2,
            answer: $b63be9b0371e788c$var$currentProblem.answer,
            missingFactor: $b63be9b0371e788c$var$currentProblem.missingFactor,
            userAnswer: parseInt(selectedButton.dataset.value)
        });
    }
    resultDiv.classList.remove('hide');
    // Disable all options to prevent multiple answers
    document.querySelectorAll('.answer-option').forEach((button)=>{
        button.disabled = true;
        if (button !== selectedButton && !button.classList.contains('correct')) button.classList.add('hidden');
    });
    $b63be9b0371e788c$var$updateScoreDisplay();
    $b63be9b0371e788c$var$currentQuestionNumber++;
    $b63be9b0371e788c$var$updateQuestionCounters();
    // Wait before showing next problem
    const timerLength = isCorrect ? 800 : 1600;
    setTimeout(()=>{
        questionCard.classList.remove('correct-animation');
        questionCard.classList.remove('wrong-animation');
        $b63be9b0371e788c$var$showNextProblem();
    }, timerLength);
};
// Add a function to return to configuration from results
window.closeResults = function() {
    $b63be9b0371e788c$var$resetAll(0);
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';
    document.getElementById('configSection').classList.remove('hidden');
    document.getElementById('practiceSection').classList.add('hidden');
};
window.resumeGame = function() {
    document.getElementById('questionCard').style.display = 'flex';
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';
    document.getElementById('answer').focus();
};
window.retryMistakes = function() {
    // Create new problems array from wrong answers
    $b63be9b0371e788c$var$problems = $b63be9b0371e788c$var$answersHistory.wrong.map((item)=>({
            num1: item.num1,
            num2: item.num2,
            answer: item.answer,
            missingFactor: item.missingFactor
        }));
    // Shuffle the problems
    $b63be9b0371e788c$var$problems = $b63be9b0371e788c$var$problems.sort(()=>Math.random() - 0.5);
    $b63be9b0371e788c$var$resetAll($b63be9b0371e788c$var$problems.length) // Set to number of mistakes
    ;
    // Hide the results modal and backdrop
    document.getElementById('finalScore').style.display = 'none';
    document.getElementById('backdrop').style.display = 'none';
    // Show the practice section
    document.getElementById('configSection').classList.add('hidden');
    document.getElementById('practiceSection').classList.remove('hidden');
    // Start the practice with the mistake problems
    document.getElementById('questionCard').style.display = 'flex';
    if (!$b63be9b0371e788c$var$isUnlimited) {
        clearInterval($b63be9b0371e788c$var$timerInterval);
        $b63be9b0371e788c$var$startTimer();
    }
    $b63be9b0371e788c$var$showNextProblem();
};
window.setDifficulty = function(level) {
    $b63be9b0371e788c$var$isUnlimited = level === 'unlimited';
    document.getElementById('timer').style.display = $b63be9b0371e788c$var$isUnlimited ? 'none' : 'flex';
    switch(level){
        case 'unlimited':
            $b63be9b0371e788c$var$timeLeft = Infinity;
            break;
        case 'easy':
            $b63be9b0371e788c$var$timeLeft = 90;
            break;
        case 'medium':
            $b63be9b0371e788c$var$timeLeft = 60;
            break;
        case 'hard':
            $b63be9b0371e788c$var$timeLeft = 30;
            break;
    }
    $b63be9b0371e788c$var$updateTimer();
};
function $b63be9b0371e788c$var$getTimeLimit() {
    const difficulty = document.getElementById('difficulty').value;
    switch(difficulty){
        case 'easy':
            return 90;
        case 'medium':
            return 60;
        case 'hard':
            return 30;
        default:
            return null;
    }
}
// ----- LISTENERS
//  keyboard support for closing modals
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        // Close message modal if it's open
        const messageModal = document.getElementById('messageModal');
        if (messageModal.style.display === 'flex') closeMessage();
        // Close end game modal if it's open
        const finalScore = document.getElementById('finalScore');
        if (finalScore.style.display === 'block') closeResults();
    }
});
// Allow Enter key to submit answer
document.getElementById('answer').addEventListener('keyup', function(event) {
    if (event.key === 'Enter') checkAnswer();
});
// Better input handling for mobile
document.getElementById('answer').addEventListener('focus', function() {
    if (window.innerWidth < 768) // Scroll the viewport to show the input field
    setTimeout(()=>{
        this.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, 300);
});
// Add touch event handling
document.getElementById('answer').addEventListener('touchend', function(event) {
    event.preventDefault();
    this.focus();
});
// Improve modal scrolling on mobile
document.getElementById('finalScore').addEventListener('touchmove', function(event) {
    event.stopPropagation();
}, {
    passive: true
});
// Initialize sound preference
document.addEventListener('DOMContentLoaded', ()=>{
    // Exit button listener
    document.getElementById('exitButton').addEventListener('click', $b63be9b0371e788c$var$exitPractice);
    // Sound initialization
    const soundIcon = document.getElementById('soundIcon');
    soundIcon.classList.toggle('muted', $b63be9b0371e788c$var$isSoundMuted);
    soundIcon.classList.toggle('unmuted', !$b63be9b0371e788c$var$isSoundMuted);
    // Retrieve the stored checked checkboxes from localStorage
    const storedNumbers = localStorage.getItem('selectedNumbers');
    $b63be9b0371e788c$var$selectedNumbers = storedNumbers ? storedNumbers.split(',') : [
        '2'
    ]; // 2 is the default check box
    // Checkbox prevention for last checked
    const checkboxes = document.querySelectorAll('.checkbox-grid input[type="checkbox"]');
    checkboxes.forEach((checkbox)=>{
        checkbox.checked = $b63be9b0371e788c$var$selectedNumbers.includes(checkbox.value);
        checkbox.addEventListener('click', function(event) {
            const checkedCount = document.querySelectorAll('.checkbox-grid input[type="checkbox"]:checked').length;
            if (!this.checked && checkedCount === 0) {
                event.preventDefault();
                $b63be9b0371e788c$var$showMessage("\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D0\u05D7\u05D3");
            }
        });
    });
    // Set checkbox
    const multiChoiceCheckbox = document.getElementById("multiChoice");
    const advancedCheckbox = document.getElementById("missingFactor");
    // If the saved mode is "multiple", mark the checkbox as checked
    multiChoiceCheckbox.checked = localStorage.getItem("gameMode") === "multiChoice";
    advancedCheckbox.checked = localStorage.getItem("isAdvanced") === "Yes";
    // Add event listener to the checkbox
    multiChoiceCheckbox.addEventListener("change", (e)=>localStorage.setItem("gameMode", e.target.checked ? "multiChoice" : "input"));
    // Add event listener to the checkbox
    advancedCheckbox.addEventListener("change", (e)=>{
        localStorage.setItem("isAdvanced", e.target.checked ? "Yes" : "No");
    });
    // select drop down init
    const selectElement = document.getElementById('difficulty');
    const savedDifficulty = localStorage.getItem('difficulty');
    if (savedDifficulty) selectElement.value = savedDifficulty; // Set the select value
    // 2. Save the value to localStorage on change
    selectElement.addEventListener('change', (e)=>{
        localStorage.setItem('difficulty', e.target.value); // Store in localStorage
    });
    $b63be9b0371e788c$var$setupModalCloseOnBackdropClick();
});
// // Prevent double-tap zoom on iOS
// document.addEventListener('touchend', function(event) {
//     event.preventDefault();
//     event.target.click();
// }, false);
// Prevent zoom when focusing input on iOS
document.addEventListener('gesturestart', function(event) {
    event.preventDefault();
});


//# sourceMappingURL=path0.1967ef42.js.map
